<template>
  <div class="media-preview">
    <div class="media-container">
      <button class="btn-close btn-close-white" @click="close">&times;</button>
      <div class="w-100 h-100 overflow-auto">
        <div class="lead text-center pt-3 pb-5 px-3 text-uppercase fw-bold">
          Select date
        </div>
        <v-date-picker
          is-dark
          class="d-block mx-auto"
          :value="selectedDate"
          :mode="mode || 'date'"
          trim-weeks
          @input="dateInputChange"
        />
        <div class="text-center p-3">
          <button class="btn btn-secondary me-3" @click="close">Cancel</button>
          <button class="btn btn-primary ms-3" @click="dateSelected">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "date-time-selector",
  props: ["date", "mode"],
  data() {
    return {
      selectedDate: null,
    };
  },
  methods: {
    dateInputChange(e) {
      this.selectedDate = e;
    },
    dateSelected() {
      if (this.selectedDate === null) {
        Swal.fire("", "Please select valid date", "warning");
      } else {
        this.$emit("close", this.selectedDate);
      }
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    this.selectedDate = this.date;
  },
};
</script>